/*
 * Copyright (C) Fraunhofer IESE 2021-2024 - Pedram (Majid) Jokar, Mher Ter-Tovmasyan,
 * Bestin John, Steffen Hupp, Anna Kleiner, Rafael Aranda Lopez King, Emily Calvet, Philipp Ewen,
 * Matthias Gerbershagen, Milad Chatrangoon, Stefan Schweitzer
 *
 * SPDX-License-Identifier: AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

export const chooseOrganizationPageEn = {
  navigateTo: "Back to solution {{solution}}",
  help: "Select an existing organization or create a new one to add it to {{solution}}. Thanks to central management through your {{appName}} account, you only need to create your organization once and can easily add it to various services.",
  createAndAdd: "Create and add to {{solution}}",
  create: {
    title: "Create Organization",
    description: "You are not yet in any organization.",
    createDescription:
      "Create a new organization at {{appName}}. Members and the organization's profile can be centrally managed for all solutions in your {{appName}} account.",
  },
  select: {
    title: "Select Organization",
    help: "Select an existing organization or create a new one to add it to DorfFunk. Thanks to central management through your {{appName}} account, you only need to create your organization once and can easily add it to various services.",
    description: "Select or create an organization to add it to {{solution}}.",
    search: "Search Organization",
    organizationLogoAlt: "Logo of organization {{organization}}",
    create: "Create New Organization",
    add: "Add to {{solution}}",
  },
  error: "Please check the URL parameters.",
};
